import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { useEffect, useState } from 'react';
import * as setup from 'setup';

export default function SettingsStats() {

    const [buffs, setBuffs] = useState<SettingsStatsBuff[]>([]);
    const [buffsActive, setBuffsActive] = useState(0);
    const [events, setEvents] = useState<GameStateEntity>({ active: [], created: 0, removed: 0 });
    const game = useGame();
    
    useEffect(() => {
        // Get buffs
        const newBuffs = Object.entries(game.entities.ants.buffs).map(([name, value]) => ({ name, value }));
        setBuffs(newBuffs);

        // Get active buffs
        const newBuffsActive = newBuffs.filter(buff => buff.value).length;
        setBuffsActive(newBuffsActive);

        // Get events
        const newEvents = {
            active: Object.keys(game.events),
            created: Object.keys(setup.events).length,
            removed: 0,
        };
        newEvents.removed = newEvents.created - newEvents.active.length;
        setEvents(newEvents);
    }, [
        game.entities.ants.buffs,
        game.events,
    ]);

    const Cell = ({ type, value }: SettingsStatsCellProps) => (
        <TableCell align="right" sx={{ fontWeight: value ? 600 : 400 }} title={type ? `${value} ${type}` : undefined}>
            {value}
        </TableCell>
    );

    const EntityRow = ({ data, name }: SettingsStatsEntityRowProps) => (
        <TableRow hover>
            <TableCell>
                {name}
            </TableCell>
            <Cell type="Active" value={data.active.length} />
            <Cell type="Created" value={data.created} />
            <Cell type="Removed" value={data.removed} />
        </TableRow>
    );

    const SimpleRow = ({ name, value }: SettingsStatsSimpleRowProps) => (
        <TableRow hover>
            <TableCell colSpan={3}>
                {name}
            </TableCell>
            <Cell value={value} />
        </TableRow>
    );

    return <Box display="flex" flexDirection="row" gap={4}>
        <Box flex={1}>
            <Table padding="none" size="small">
                <TableHead>
                    <SimpleRow name="Turns" value={game.turns} />
                </TableHead>
                <TableBody>
                    <SimpleRow name="Snapshots" value={game.snapshot.index} />
                    <SimpleRow name="Retries" value={game.retries} />
                    <EntityRow name="Events" data={events} />
                    <EntityRow name="Foods" data={game.entities.foods} />
                    <EntityRow name="Natures" data={game.entities.natures} />
                </TableBody>
            </Table>
        </Box>

        <Box flex={1}>
            <Table padding="none" size="small">
                <TableHead>
                    <EntityRow name="Ants" data={game.entities.ants} />
                </TableHead>
                <TableBody>
                    <EntityRow name="Explorers" data={game.entities.ants.explorers} />
                    <SimpleRow name="- Mutations" value={game.entities.ants.explorers.mutations} />
                    <EntityRow name="Queens" data={game.entities.ants.queens} />
                    <EntityRow name="Warriors" data={game.entities.ants.warriors} />
                    <EntityRow name="Workers" data={game.entities.ants.workers} />
                </TableBody>
            </Table>
        </Box>

        <Box flex={1}>
            <Table padding="none" size="small">
                <TableHead>
                    <EntityRow name="Dangers" data={game.entities.dangers} />
                </TableHead>
                <TableBody>
                    <EntityRow name="Ant Warriors" data={game.entities.dangers.antWarriors} />
                    <EntityRow name="Ant Workers" data={game.entities.dangers.antWorkers} />
                    <EntityRow name="Anteaters" data={game.entities.dangers.anteaters} />
                    <EntityRow name="Lawnmowers" data={game.entities.dangers.lawnmowers} />
                    <EntityRow name="Magnifiers" data={game.entities.dangers.magnifiers} />
                    <EntityRow name="Spiders" data={game.entities.dangers.spiders} />
                </TableBody>
            </Table>
        </Box>

        <Box flex={1}>
            <Table padding="none" size="small">
                <TableHead>
                    <TableRow hover>
                        <TableCell>
                            Buffs
                        </TableCell>
                        <Cell value={buffsActive} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {buffs.map((buff, index) => (
                        <TableRow hover key={index}>
                            <TableCell>
                                {buff.name}
                            </TableCell>
                            <Cell value={buff.value} />
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    </Box>;

}